import { TimelineMax } from 'gsap';
import { Power3 } from 'gsap/TweenLite';

const TextEnter = (element) => {
  const chars = Array.from(element.querySelectorAll('.live-content__block-char'));

  const tl = new TimelineMax({ paused: true });
  tl.addLabel('start')
    .staggerTo(chars, 0.8, {
      y: 0,
      autoAlpha: 1,
      ease: Power3.easeOut,
    }, 0.02);
  return tl;
};

export default TextEnter;
